"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultReducer = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.is.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.map.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.promise.js");

var _constants = require("./constants");

var _tools = require("./tools");

var _subscribe = _interopRequireDefault(require("./subscribe"));

var _unsubscribe = _interopRequireWildcard(require("./unsubscribe"));

var _genRaceQueue = _interopRequireWildcard(require("./genRaceQueue"));

var _runtimeVar = _interopRequireDefault(require("./runtimeVar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultReducer = function defaultReducer(data, _state) {
  return data;
};

exports.defaultReducer = defaultReducer;
var warning = '你只传入了一个函数参数给gluer，这会被认为是reducer函数而不是初始值。如果你想存储一个函数类型的初始值，请传入两个参数：reducer和初始值。' + 'reducer可以是最简单：(data, state) => data。这个的意思是：传入的数据会直接用来更新state。';

var getWarning = function getWarning(rd) {
  return "".concat(warning).concat(rd.toString());
};

var raceHandle = function raceHandle(promise, callback, deprecatedFlag) {
  var errorFlag = deprecatedFlag || _constants.promiseDeprecated;

  if (errorFlag in promise) {
    callback();
    throw _genRaceQueue.promiseDeprecatedError;
  }

  promise[errorFlag] = true;
};

var executeCallback = function executeCallback(targetDeps) {
  var callback = _unsubscribe.depsToFnMap.get(targetDeps);

  callback.forEach(function (call) {
    var values = [];

    for (var k = 0; k < targetDeps.length; k += 1) {
      values.push(targetDeps[k]());
    }

    call.apply(void 0, values);
  });
};

function gluer() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var rd = args[0],
      initialState = args[1];
  var reducerFnc;
  var initState = initialState;

  if (args.length === 0) {
    reducerFnc = defaultReducer;
  } else if (args.length === 1) {
    if (typeof rd !== 'function') {
      reducerFnc = defaultReducer;
      initState = rd;
    } else {
      reducerFnc = rd;

      if (process.env.NODE_ENV === 'development') {
        console.warn(getWarning(rd));
      }
    }
  } else {
    if (typeof rd !== 'function') {
      throw new Error('first argument must be function');
    }

    reducerFnc = rd;
  }

  var gluerState = initState;
  var trackArr = [];
  var curIndex = 0;
  var rq = (0, _genRaceQueue.default)();
  var unsubscribeRelyArr = [];
  var cachedData;
  var cachedFlag = false;
  var fromCache = false;
  var fn;
  var selfDeps = [];

  var updateFn = function updateFn(data, silent) {
    var mutedDeps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var curFromCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (curFromCache && !cachedFlag) {
      cachedFlag = true;
      cachedData = data;
    }

    if (!Object.is(data, gluerState)) {
      gluerState = data;

      if (!silent) {
        var length = trackArr.length;

        if (length) {
          if (curIndex < length - 1) {
            trackArr.splice(curIndex + 1);
          }

          trackArr.push(gluerState);
          curIndex += 1;
        }

        var targetDeps = _unsubscribe.refToDepsMap.get(fn);

        if (targetDeps) {
          targetDeps.forEach(function (target) {
            if (!mutedDeps.includes(target)) {
              executeCallback(target);
            }
          });
        }
      }
    }
  };

  var preTreat = function preTreat() {
    var payload;
    var customHandler;

    for (var _len2 = arguments.length, ags = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      ags[_key2] = arguments[_key2];
    }

    if (ags.length === 0) {
      return gluerState;
    }

    if (ags.length === 1) {
      if (typeof ags[0] === 'function') {
        customHandler = ags[0];
      } else {
        payload = ags[0];
      }
    } else {
      payload = ags[0];
      customHandler = ags[1];
    }

    var realHandler = customHandler || reducerFnc;
    return realHandler(payload, gluerState);
  };

  var basicLogic = function basicLogic() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function () {
      for (var _len3 = arguments.length, ags = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        ags[_key3] = arguments[_key3];
      }

      var tempResult = preTreat.apply(void 0, ags);
      if (ags.length === 0) return tempResult;

      if (!silent) {
        if (_runtimeVar.default.runtimeDepsModelCollectedMap.has(fn)) return tempResult;

        _runtimeVar.default.runtimeDepsModelCollectedMap.set(fn, 0);
      }

      var deleteSelf = function deleteSelf() {
        if (!silent) {
          _runtimeVar.default.runtimeDepsModelCollectedMap.delete(fn);
        }
      };

      var mutedDeps = ags[2];

      if ((0, _tools.isAsync)(tempResult)) {
        var forAsyncRuntimeDepsModelCollectedMap;

        if (!silent) {
          forAsyncRuntimeDepsModelCollectedMap = new Map(_runtimeVar.default.runtimeDepsModelCollectedMap);
        }

        if (process.env.NODE_ENV === 'development' && (0, _tools.isTagged)(tempResult)) {
          console.warn('传入的promise已经被model使用了，请勿重复传入相同的promise，这样可能导致异步竞争，从而取消promise！');
        }

        var tmpFromCache = fromCache;

        var depsClearCallback = function depsClearCallback() {
          forAsyncRuntimeDepsModelCollectedMap = null;
        };

        var promise = tempResult.catch(function (e) {
          raceHandle(promise, depsClearCallback);
          return Promise.reject(e);
        }).then(function (data) {
          raceHandle(promise, depsClearCallback);

          if (!silent) {
            _runtimeVar.default.runtimeDepsModelCollectedMap = forAsyncRuntimeDepsModelCollectedMap;
          }

          updateFn(data, silent, mutedDeps, tmpFromCache);

          if (!silent) {
            _runtimeVar.default.runtimeDepsModelCollectedMap.clear();
          }

          return data;
        });

        if (process.env.NODE_ENV === 'development') {
          (0, _tools.tagPromise)(promise);
        }

        deleteSelf();
        return promise;
      }

      updateFn(tempResult, silent, mutedDeps);
      deleteSelf();
      return tempResult;
    };
  };

  var historyGoUpdateFn = function historyGoUpdateFn(step) {
    var length = trackArr.length;

    if (length === 0) {
      return;
    }

    curIndex += step;

    if (curIndex < 0) {
      curIndex = 0;
    } else if (curIndex > length - 1) {
      curIndex = length - 1;
    }

    var data = trackArr[curIndex];

    if (!Object.is(data, gluerState)) {
      gluerState = data;

      var targetDeps = _unsubscribe.refToDepsMap.get(fn);

      if (targetDeps) {
        targetDeps.forEach(function (targetDep) {
          executeCallback(targetDep);
        });
      }
    }
  };

  fn = basicLogic(false);

  fn.reset = function () {
    fn(initState);
  };

  fn.relyOn = function (models, callback) {
    if (!(0, _tools.isArray)(models) || models.length === 0) {
      throw new Error('dependencies should be Array, ant not empty');
    }

    var unsub = (0, _subscribe.default)(models, function () {
      if (_runtimeVar.default.runtimeDepsModelCollectedMap.has(fn)) return;

      for (var _len4 = arguments.length, data = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        data[_key4] = arguments[_key4];
      }

      fn(callback(data, fn()));
    }, false);
    unsubscribeRelyArr.push(unsub);
    return unsub;
  };

  var relyOffFn = function relyOffFn(targetDeps) {
    if (targetDeps === undefined) {
      for (var i = 0; i < unsubscribeRelyArr.length; i += 1) {
        var f = unsubscribeRelyArr[i];
        f();
      }

      unsubscribeRelyArr = [];
    } else {
      (0, _unsubscribe.default)(targetDeps);
    }
  };

  fn.off = relyOffFn;
  fn.relyOff = relyOffFn;

  fn.onChange = function (callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback should be function');
    }

    return (0, _subscribe.default)(selfDeps, callback, false);
  };

  fn.offChange = function (callback) {
    (0, _unsubscribe.default)(selfDeps, callback);
  };

  fn.silent = basicLogic(true);

  fn.track = function () {
    if (!trackArr.length) {
      trackArr.push(gluerState);
      curIndex = 0;
    }
  };

  fn.flush = function () {
    if (trackArr.length) {
      trackArr.splice(0);
      curIndex = 0;
    }
  };

  fn.go = function (step) {
    if (_runtimeVar.default.runtimeDepsModelCollectedMap.has(fn)) return gluerState;

    _runtimeVar.default.runtimeDepsModelCollectedMap.set(fn, 0);

    historyGoUpdateFn(step);

    _runtimeVar.default.runtimeDepsModelCollectedMap.delete(fn);

    return gluerState;
  };

  fn.race = function () {
    return rq.push(fn.apply(void 0, arguments), _runtimeVar.default.runtimePromiseDeprecatedFlag);
  };

  fn.preTreat = function () {
    return preTreat.apply(void 0, arguments);
  };

  fn.cache = function () {
    if (arguments.length === 0) {
      return cachedData;
    }

    fromCache = true;
    var result;

    if (cachedFlag) {
      result = fn.race(function () {
        return Promise.resolve(cachedData);
      });
    } else {
      var _fn;

      result = (_fn = fn).race.apply(_fn, arguments);
    }

    fromCache = false;
    return result;
  };

  fn.cacheClean = function () {
    cachedFlag = false;
    cachedData = undefined;
  };

  Object.defineProperty(fn, _constants.gluerUniqueFlagKey, {
    value: _constants.gluerUniqueFlagValue,
    writable: false,
    configurable: true,
    enumerable: true
  });
  selfDeps = [fn];
  return fn;
}

var _default = gluer;
exports.default = _default;